import { havErrorAlert } from './components/Alerts'
import {
  havPrimaryButton,
  havBigPrimaryButton,
  havGhostButton,
  havIconButton,
  havTextButton
} from './components/Buttons'
import { havModalShape } from './components/Modal'
import { havPagination } from './components/Pagination'
import { havComplexTable, havSimpleTable } from './components/Tables'

import {
  havDefault01Text,
  havDefault02Text,
  havH1Text,
  havH2Text,
  havH3Text,
  havH4Text,
  havH5Text,
  havSubtitleText
} from './components/Texts'
import { havMasterFieldInput } from './components/Inputs'
import { HAVDesignTokensInterface } from './interfaces'
import { palette, spacing, typography, shape, icon } from './values'
import { havAccordion } from './components/Accordion'
import { havTag } from './components/Tag'

let HAVDesignTokens: HAVDesignTokensInterface = {
  palette,
  spacing,
  typography,
  shape,
  icon
}

HAVDesignTokens = {
  ...HAVDesignTokens,
  DSComponents: {
    buttons: {
      havPrimaryButton: havPrimaryButton(HAVDesignTokens),
      havBigPrimaryButton: havBigPrimaryButton(HAVDesignTokens),
      havGhostButton: havGhostButton(HAVDesignTokens),
      havIconButton: havIconButton(HAVDesignTokens),
      havTextButton: havTextButton(HAVDesignTokens)
    },
    shapes: {
      havModalShape: havModalShape(HAVDesignTokens)
    },
    texts: {
      havH1Text: havH1Text(HAVDesignTokens),
      havH2Text: havH2Text(HAVDesignTokens),
      havH3Text: havH3Text(HAVDesignTokens),
      havH4Text: havH4Text(HAVDesignTokens),
      havH5Text: havH5Text(HAVDesignTokens),
      havSubtitleText: havSubtitleText(HAVDesignTokens),
      havDefault01Text: havDefault01Text(HAVDesignTokens),
      havDefault02Text: havDefault02Text(HAVDesignTokens)
    },
    inputs: {
      havMasterFieldInput: havMasterFieldInput(HAVDesignTokens)
    },
    tables: {
      havSimpleTable: havSimpleTable(HAVDesignTokens),
      havComplexTable: havComplexTable(HAVDesignTokens)
    },
    alerts: {
      havErrorAlert: havErrorAlert(HAVDesignTokens)
    },
    accodion: {
      havAccordion: havAccordion(HAVDesignTokens)
    },
    tag: {
      havTag: havTag(HAVDesignTokens)
    },
    pagination: {
      havPagination: havPagination(HAVDesignTokens)
    }
  }
}

export default HAVDesignTokens
